import React, { useState } from 'react'
import { Link } from 'react-router-dom'

export const Navbar = () => {
  return (
    <>
        <nav className="flex justify-end items-center w-[96%] py-4">
            <div className="">
                <ul className="flex items-center gap-[4vw]">
                  <li className="hover:text-blue-200">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="hover:text-blue-200">
                    <Link to="/project">Projects</Link>
                  </li>
                  <li className="hover:text-blue-200">
                    <Link to="/resume">Resume</Link>
                  </li>
                  <li className="hover:text-blue-200">
                    <Link to="/contact">Contact</Link>
                  </li>
                  <li>
                    <Link to="https://github.com/JustBacon">
                      <img src={require("../assets/github-mark-white.png")} alt="github-logo" className="h-10 w-auto" />
                    </Link>
                  </li>
                </ul>
            </div>
        </nav>
    </>
  )
}

